import request from "./http";
import { CUENTAS_ENDPOINT } from "../infrastructure/appConstants";

const cuentaService = {
  listCuentas: () => request.get(`${CUENTAS_ENDPOINT}/cuenta/listar`),
  cuentaDetail: (req) =>
    request.post(`${CUENTAS_ENDPOINT}/cuenta/obtener`, req),
  listMovimientos: (req) =>
    request.post(`${CUENTAS_ENDPOINT}/movimiento/listar`, req),
  aperturarCuentaAhorrosValidar: (req) =>
    request.post(`${CUENTAS_ENDPOINT}/apertura-cuenta-ahorros/validar`, req),
  aperturarCuentaAhorrosConfirmar: (req) =>
    request.post(`${CUENTAS_ENDPOINT}/apertura-cuenta-ahorros/confirmar`, req),
  aperturarCuentaDPFValidar: (req) =>
    request.post(`${CUENTAS_ENDPOINT}/apertura-cuenta-plazo-fijo/validar`, req),
  aperturarCuentaDPFConfirmar: (req) =>
    request.post(
      `${CUENTAS_ENDPOINT}/apertura-cuenta-plazo-fijo/confirmar`,
      req
    ),
  listCuentasOperaciones: () =>
    request.get(`${CUENTAS_ENDPOINT}/operacion-retiro/listar`),
  listCuentasOperacionesPrymera: () =>
    request.get(`${CUENTAS_ENDPOINT}/operacion-retiro-entre-prymera/listar`),
  listCuentasDeposito: () =>
    request.get(`${CUENTAS_ENDPOINT}/operacion-deposito/listar`),
  listarProductosCuentaApertura: (req) =>
    request.post(`${CUENTAS_ENDPOINT}/producto-cuenta/listar`, req),
};

export default cuentaService;
